import { useTranslation } from 'react-i18next'
import { shallowEqual } from 'react-redux'

import { useTitle } from 'features/assessmentQuestions/hooks/useTitle'
import { useCharlieUser } from 'hooks/useCharlieUser'
import { AreaType } from 'store/area/types'
import { useGetAuditAreasQuery } from 'store/audit/auditApiWithQuery'
import { useAppSelector } from 'store/hooks'
import { State } from 'store/state'

import { insightsAssessmentViewedEvent } from 'utils/analytics/amplitudeEvents'

import { IReportsSidebarMenuGroup } from '../types/reportSidebarMenuGroup'

export const useMenuGroupAssessment = (): {
  sidebarItems: IReportsSidebarMenuGroup | undefined
} => {
  const { t } = useTranslation()

  const { sessionId } = useAppSelector(
    (state: State) => ({
      sessionId: state.apiHeadersReducer.sessionId,
    }),
    shallowEqual
  )

  const { data: areas } = useGetAuditAreasQuery({
    sessionId,
    query: { type: AreaType.SUB },
  })

  const { title } = useTitle()
  const charlieUser = useCharlieUser()

  const ASSESSMENT_CODE = 'assessment'

  if (areas && title) {
    return {
      sidebarItems: {
        code: ASSESSMENT_CODE,
        enabled: true,
        text: title,
        url: `/${ASSESSMENT_CODE}`,
        items:
          areas?.length > 0
            ? areas
                .map(({ code, title: areaTitle }) => ({
                  code,
                  text: areaTitle,
                  url: `/${ASSESSMENT_CODE}/${code}`,
                  enabled: true,
                  onClick: () =>
                    insightsAssessmentViewedEvent({ topic: code }, charlieUser),
                }))

                .concat({
                  code: 'changelog',
                  text: t('nav.settings.assessment'),
                  url: `/${ASSESSMENT_CODE}/changelog`,
                  enabled: true,
                  onClick: () =>
                    insightsAssessmentViewedEvent(
                      { topic: 'changelog' },
                      charlieUser
                    ),
                })
            : undefined,
      },
    }
  }
  return { sidebarItems: undefined }
}
